import React from 'react';
import { createRoot } from 'react-dom/client';
import { getDeviceType } from './utils/deviceDetection';

import '../scss/styles.scss';

import App from 'js/App';
import { DOM_ID } from 'js/constants/App';

const doRender = (Component = App, el) => {
  const root = createRoot(el);
  root.render(<Component />);

  const loader = document.getElementById('preloader');
  if (loader) {
    loader.style.display = 'none';
  }
};

const mountApp = () => {
  const deviceType = getDeviceType();
  document.getElementsByTagName('html')[0].classList.add(deviceType);
  // document.getElementById('type').innerHTML = `{type: ${deviceType}, innerWidth: ${
  //   window?.innerWidth || 0
  // }, innerHeight: ${window?.innerHeight || 0}, outerWidth: ${window?.outerWidth || 0}, outerHeight: ${
  //   window?.outerHeight || 0
  // } }`;

  const el = document.getElementById(DOM_ID);
  if (el === null) {
    console.error(`Dom node ${DOM_ID} is missing - aborting app`);
  } else {
    doRender(App, el);

    if (import.meta.hot) {
      import.meta.hot.accept();
    }
  }
};

window.addEventListener('load', mountApp);
